/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import NewTable from '../../components/NewTable/NewTable'
import { useDispatch, useSelector } from 'react-redux'
import { coinManagementActions, userManagementActions } from '../../_actions'
import { TbInfoCircleFilled } from "react-icons/tb";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useNavigate } from 'react-router';
import CountCard from '../../components/Atoms/Card Count/CountCard';
import ViewMoreInfo from '../UserDetails/More Info/ViewMoreInfo';
import Pagination from '../../components/Pagination/Pagination';
import Loader from '../../components/Atoms/Loader';

const size = 10
const P2PHistory = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const { userManagement: { getP2POrderHistoryList } } = selector ? selector : {}
  const { list, total } = getP2POrderHistoryList ? getP2POrderHistoryList : {}
  const [, setP2PHis] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('ALL');
  const [sortBy2, setSortBy2] = useState("BUY")
  const [pageNo, setPageNo] = useState(1)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState('')
  const [count, setCount] = useState([])
  const [isMoreInfoModal, setIsMoreInfoModal] = useState('')
  const [isMoreInfoData, setIsMoreInfoData] = useState(null)


  const handleChat = (orderId) => {
    navigate(`/app/p2p-history/p2p-chat?orderId=${encodeURIComponent(orderId)}`);
  };

  useEffect(() => {
    function getCountList() {
      coinManagementActions.getAmountAndCount({ type: "P2P_HISTORY" }).then((res) => {
        if (res) {
          setCount(res?.data)
        }
      }).catch((err) => console.log(err))
    }
    getCountList()
  }, []);



  const sortingOptions = [
    { value: 'ALL', label: 'Sort by All' },
    { value: 'PENDING', label: 'Sort by Active' },
    { value: 'PAYMENT_RECEIVED', label: 'Sort by In Progress' },
    { value: 'COMPLETED', label: 'Sort by Completed' },
    { value: 'CANCELLED', label: 'Sort by Canceled' },

  ];

  const sortingOptions2 = [
    { value: 'BUY', label: 'Sort by Buy' },
    { value: 'SELL', label: 'Sort by Sell' },
  ]

  const details = {
    keyWord: "",
    sortBy: "createdAt",
    sortOrder: "desc",
    pageNo: pageNo,
    size: size,
    fromDate: fromDate,
    toDate: toDate,
    status: sortBy,
    orderType: sortBy2
  }

  useEffect(() => {
    dispatch(userManagementActions.orderHistory(details))
    setP2PHis(list);
  }, [pageNo, size, sortBy, fromDate, toDate, sortBy2])

  useEffect(() => {
    setP2PHis(list);
  }, [pageNo, selector, fromDate, toDate, dispatch]);


  const calculatePositiveRating = (totalOrders, positiveRatings) => {
    if (totalOrders === 0) return "0%"; // Avoid division by zero
    return `${((positiveRatings / totalOrders) * 100).toFixed(4)}%`;
  };

  const tableHeadings = ['Advertisers', 'Asset', 'Price', 'Mode', 'Trade ', 'Status', "Chat", 'Date & Time', 'Info']
  const tableRows = list?.map((ele, index) => [
    <div className="flex flex-col" key={`advertiser-${index}`}>
      <div className="text-[#000000]">
        {ele.advertiser?.name || 'N/A'}
      </div>

      <div className="flex justify-start items-center gap-2 text-sm text-gray-600">
        <span>{ele.totalOrders || 'N/A'} Orders</span>|
        <span>{ele.totalCompleteOrder || '0'} Completion</span>
      </div>

      <div className="flex justify-start items-center gap-2 text-sm text-gray-600">
        <span>{calculatePositiveRating(ele?.totalOrders, ele?.positiveRatings)}</span>|
        <span>{ele.adId?.tradeLimitTime || 'N/A'} min</span>
      </div>

      <p className="text-xs text-red-500">
        {Array.isArray(ele.adId?.tradeTerms) && ele.adId.tradeTerms.length > 0
          ? "Requires Verification"
          : ""}
      </p>
    </div>,

    <span key={`asset-${index}`}>
      {ele.adId?.asset || 'N/A'}
    </span>,

    ele.tradeRate?.toFixed(4) || 'N/A',

    <span key={`payment-${index}`}>
      {`${ele.payMethod?.methodShortName} (${ele.payMethod?.methodType})` || 'N/A'}
    </span>,

    ele.orderType || 'N/A',

    <div className="flex items-center gap-1" key={`status-${index}`}>
      <div
        className={`w-1 h-4 rounded-full ${ele.orderStatus === 'CANCELLED' ? 'bg-red-500' : 'bg-green-500'}`}
      ></div>
      {ele.orderStatus ? ele.orderStatus.charAt(0).toUpperCase() + ele.orderStatus.slice(1).toLowerCase() : 'N/A'}
    </div>

    ,

    <div key={`chat-${index}`}>
      <MdOutlineRemoveRedEye
        size={25}
        onClick={() => handleChat(ele._id)}
        className="cursor-pointer"
      />
    </div>,

    <span key={`createdAt-${index}`}>
      {new Date(ele.createdAt).toLocaleString() || 'N/A'}
    </span>,

    <div key={`view-${index}`}>
      <TbInfoCircleFilled
        size={25}
        onClick={() => handleView(ele)}
        className="cursor-pointer"
      />
    </div>
  ]);


  const salesData = [
    {
      title: "Active",
      count: count?.active?.count ?? 0,
      amount: isNaN(count?.active?.amount) ? 0 : count.active.amount,
    },
    {
      title: "Completed",
      count: count?.complete?.count ?? 0,
      amount: isNaN(count?.complete?.amount) ? 0 : count.complete.amount,
    },
    {
      title: "Cancel",
      count: count?.cancel?.count ?? 0,
      amount: isNaN(count?.cancel?.amount) ? 0 : count.cancel.amount,
    },
    {
      title: "In Progress",
      count: count?.inprogress?.count ?? 0,
      amount: isNaN(count?.inprogress?.amount) ? 0 : count.inprogress.amount,
    },
  ];


  const handleDateRangeChange = (start, end) => {
    setFromDate(start)
    setToDate(end)
    setPageNo(1)
  };


  const handleView = (data) => {
    setIsMoreInfoData(data)
    setIsMoreInfoModal(true)
  }

  const closeModal = () => {
    setIsMoreInfoData(null)
    setIsMoreInfoModal(false)
  }


  const onSortByStatus = (e) => {
    setSortBy(e.target.value)
    setPageNo(1)
  }

  const onSortByStatus2 = (e) => {
    setSortBy2(e.target.value)
    setPageNo(1)
  }


  const onPageChange = page => {
    setPageNo(page)

  }

  return (
    <>
      <Loader loading={selector?.userManagement?.loading} />
      <div className='p-6 overflow-hidden overflow-y-auto'>
        <h1 className='font-[600] text-[20px] text-[#1D1F2C] mb-4'>P2P History ({total}) </h1>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {Array.isArray(salesData) && salesData.length > 0 ? (
            salesData.map((item, idx) => (
              <CountCard
                key={idx}
                title={item.title}
                count={item.count}
                amount={item.amount}
              />
            ))
          ) : (
            <p>No sales data available.</p>
          )}

        </div>
        <NewTable
          tableHeadings={tableHeadings}
          data={tableRows}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          showSearch={false}
          placeholder="Search by name, email, phone or ID..."
          showSorting={true}
          sortStatusValue={sortBy}
          sortingOptions={sortingOptions}
          fromDate={fromDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          toDate={toDate}
          handleDateRangeChange={handleDateRangeChange}
          showDateFilter={true}
          showDropDown2={true}
          sortStatusValue2={sortBy2}
          sortingOptions2={sortingOptions2}
          showDropDown1={true}
          onSortByStatus={onSortByStatus}
          onSortByStatus2={onSortByStatus2}
        />

        {
          total > size &&
          <Pagination
            totalPages={Math.ceil(total / size)}
            currentPage={pageNo}
            onPageChange={onPageChange}
          />
        }
      </div>

      {isMoreInfoModal && (
        <ViewMoreInfo isMoreInfoData={isMoreInfoData} closeModal={closeModal} calculatePositiveRating={calculatePositiveRating} />
      )}

    </>
  )
}

export default P2PHistory
